import React, { FunctionComponent, useMemo } from 'react'
import { PieChart } from 'react-minimal-pie-chart'

import { areaChartLabel, areaChartProps } from '../../../common/chartHelpers'
import { PieChartColorPalette } from '../../utils/collorPallete'
import { useDeclension } from '../../utils/useDeclension'
import { Money } from '../Money/Money'

interface SubjectAreaSummaryItem {
  id: string
  name: string
  areaM: number
}

export interface SubjectDetailAreaSummaryChartProps {
  data: SubjectAreaSummaryItem[]
}

export const SubjectDetailAreaSummaryChart: FunctionComponent<SubjectDetailAreaSummaryChartProps> =
  props => {
    const decline = useDeclension()

    const prepareAreaData = useMemo(() => {
      let totalArea = 0
      const totalCount = props.data?.length || 0

      props.data.forEach(item => {
        totalArea += item.areaM
      })

      const pieChartData = props.data
        .filter(item => item.areaM > 0)
        .map((item, index) => ({
          title: item.name,
          value: item.areaM,
          color: PieChartColorPalette[index % PieChartColorPalette.length],
        }))

      const modalTitle = (
        <div>
          Celkem {decline(totalCount, 'area', true)} o výměře{' '}
          <Money amount={totalArea} decimalNumbers={0} symbol="m²" />
        </div>
      )

      return { modalTitle, pieChartData, totalArea, totalCount }
    }, [props.data, decline])

    const pieChartProp = useMemo(
      () => ({
        ...areaChartProps,
        data: prepareAreaData.pieChartData,
        label: areaChartLabel,
      }),
      [prepareAreaData.pieChartData]
    )

    if (!props.data || props.data.length < 2) {
      return null
    }

    return (
      <div className="max-w-2xl w-[600px] 2xl:min-w-[600px] mx-auto">
        <PieChart {...pieChartProp} />
      </div>
    )
  }
